<glxy-chat-container
  class="ph-no-capture"
  #chatContainer
  [chatId]="(conversationId$ | async) ?? ''"
  [animationDuration]="200"
>
  <!--Display when we are waiting for Open AI to respond-->
  <glxy-chat-message-group
    *ngIf="loadingOpenAIReply()"
    [type]="RECEIVED"
    [messageFrom]="OPENAI_BOT_NAME"
    [isTyping]="true"
    [messageMetadata]="'INBOX.CHAT.TYPING' | translate"
    [showProfilePic]="true"
    [profileSVGIcon]="OPENAI_BOT_SVG_ICON"
    [profileBackgroundColor]="OPENAI_BOT_BACKGROUND_COLOR"
  ></glxy-chat-message-group>

  <ng-container *ngFor="let item of groupedMessages$ | async; trackBy: trackById">
    <ng-container *ngIf="!isConversationEvent(item)">
      <ng-container [ngSwitch]="item.type">
        <ng-container
          *ngSwitchCase="MessageType.MESSAGE_TYPE_MESSAGE"
          [ngTemplateOutlet]="messageGroup"
          [ngTemplateOutletContext]="{ messageGroup: item }"
        ></ng-container>

        <ng-container
          *ngSwitchCase="MessageType.MESSAGE_TYPE_SYSTEM"
          [ngTemplateOutlet]="systemMessage"
          [ngTemplateOutletContext]="{ message: item }"
        ></ng-container>
      </ng-container>
    </ng-container>

    <glxy-chat-event
      *ngIf="isConversationEvent(item)"
      [messageMetadata]="item.happenedAt | firebaseTimestampToDate | date: 'MMM d, y, h:mm a'"
    >
      {{ item.labelKey | translate }}
    </glxy-chat-event>
  </ng-container>
</glxy-chat-container>

<ng-template #messageGroup let-messageGroup="messageGroup">
  <glxy-chat-message-group
    [type]="messageGroup.lastMessage | messageStatusType"
    [messageFrom]="(messageGroup.lastMessage | messageFrom) || ('INBOX.CHAT.UNKNOWN_CONTACT' | translate)"
    [messageMetadata]="messageGroup.lastMessage | messageVia | translate"
    [sentFromYou]="messageGroup | isFromYou"
    [showProfilePic]="true"
    [profileIcon]="messageGroup | chatProfileIcon"
    [profilePicUrl]="messageGroup.sender?.profileImageUrl"
    [profileSVGIcon]="
      messageGroup.sender?.participantType === OPENAI_BOT_TYPE && !messageGroup.sender?.profileImageUrl
        ? OPENAI_BOT_SVG_ICON
        : ''
    "
    [profileBackgroundColor]="
      messageGroup.sender?.participantType === OPENAI_BOT_TYPE && !messageGroup.sender?.profileImageUrl
        ? OPENAI_BOT_BACKGROUND_COLOR
        : !!(messageGroup | chatProfileIcon)
          ? defaultBackgroundColor
          : ''
    "
    [profileSourceIconName]="messageGroup.channel | chatSourceIconName"
  >
    <ng-container *ngFor="let message of messageGroup.messages; trackBy: trackById">
      <glxy-chat-message
        *ngIf="!!message?.body"
        [messageText]="message?.body | linky | messageCodeBacktick"
        [messageStatus]="mapMessageStatus(message)"
        [messageTime]="message.created | messageBubbleTime"
      >
        <glxy-additional-metadata class="evaluate" *ngIf="messageGroup.sender?.participantType === OPENAI_BOT_TYPE">
          <button
            class="evaluate-button"
            mat-icon-button
            [matTooltip]="'INBOX.RESPONSE_EVALUATION.HELPFUL' | translate"
            (click)="openEvaluateModal(true, message)"
          >
            <mat-icon inline="true" class="evaluate-icon">thumb_up</mat-icon>
          </button>
          <button
            class="evaluate-button"
            mat-icon-button
            [matTooltip]="'INBOX.RESPONSE_EVALUATION.NOT_HELPFUL' | translate"
            (click)="openEvaluateModal(false, message)"
          >
            <mat-icon inline="true" class="evaluate-icon">thumb_down</mat-icon>
          </button>
        </glxy-additional-metadata>
      </glxy-chat-message>
      <ng-container [ngTemplateOutlet]="mediaMessage" [ngTemplateOutletContext]="{ message: message }"></ng-container>
    </ng-container>
  </glxy-chat-message-group>

  <glxy-chat-divider-text *ngIf="!!messageGroup?.createdAt">
    {{ messageGroup.createdAt | messageTime }}
  </glxy-chat-divider-text>
</ng-template>

<ng-template #systemMessage let-message="message">
  <glxy-chat-divider-text class="system-message">
    <div [innerHTML]="message?.body | linky | messageCodeBacktick | truncateUrl"></div>
  </glxy-chat-divider-text>
</ng-template>

<ng-template #mediaMessage let-message="message">
  <ng-container *ngFor="let media of message?.media" itemContent="attachment">
    <glxy-chat-message
      [class.message-media]="media.mediaContentType | inArray: acceptedMimeType"
      [itemContent]="(media.mediaContentType | inArray: acceptedMimeType) ? 'attachment' : 'message'"
      [messageStatus]="mapMessageStatus(message)"
      [messageTime]="message.created | date: 'MMM d, y, h:mm a'"
    >
      <ng-container *ngIf="mediaWithErrorsMessageIDs().indexOf(message.id) === -1">
        <ng-container *ngIf="media.mediaContentType | inArray: acceptedMimeType; else otherFile">
          <div class="content-attachment">
            <img
              alt="media"
              class="message-media-image"
              *ngIf="media.mediaContentType.indexOf('image') !== -1"
              [src]="media | getMessageMediaUrl"
              width="100%"
              height="auto"
              (click)="openInDialog(media.mediaUrl, media.mediaContentType)"
              (error)="addMessageIdToMediaErrors(message.id)"
            />
            <video
              *ngIf="media.mediaContentType.indexOf('video') !== -1"
              width="100%"
              height="auto"
              controls="controls"
              preload="metadata"
              (click)="openInDialog(media.mediaUrl, media.mediaContentType)"
            >
              <source
                [src]="media | getMessageMediaUrl"
                [type]="media.mediaContentType"
                (error)="addMessageIdToMediaErrors(message.id)"
              />
            </video>
            <audio *ngIf="media.mediaContentType.indexOf('audio') !== -1" controls>
              <source
                [src]="media | getMessageMediaUrl"
                [type]="media.mediaContentType"
                (error)="addMessageIdToMediaErrors(message.id)"
              />
            </audio>
          </div>
        </ng-container>
      </ng-container>
      <glxy-empty-state
        size="small"
        *ngIf="mediaWithErrorsMessageIDs().indexOf(message.id) !== -1"
        class="broken-media-empty-state"
      >
        <glxy-empty-state-hero>
          <mat-icon>broken_image</mat-icon>
        </glxy-empty-state-hero>
        <p>{{ 'INBOX.ERROR.BROKEN_MEDIA_URL' | translate }}</p>
      </glxy-empty-state>
    </glxy-chat-message>

    <ng-template #otherFile>
      <a
        href="{{ mediaUrl }}"
        class="link-to-document"
        *ngIf="media | getMessageMediaUrl as mediaUrl"
        download="{{ media.mediaFileName }}"
      >
        <mat-icon [inline]="true" class="file-icon">insert_drive_file</mat-icon>
        <span class="file-name">{{ media.mediaFileName }}</span>
      </a>
    </ng-template>
  </ng-container>
</ng-template>
